const sharedClasses =
    'flex items-center justify-center text-xs md:text-base px-[15px] py-[10px] rounded uppercase w-full sm:min-w-[270px] sm:w-auto font-semibold transition-color duration-200 disabled:cursor-not-allowed disabled:opacity-30'

export const primary = {
    solidClasses: `${sharedClasses} bg-brand-primary text-brand-white hover:text-brand-white hover:no-underline hover:bg-brand-primary-lighten active:bg-brand-primary-darken`,
    outlineClasses: `${sharedClasses} bg-transparent text-brand-primary border-2 border-brand-primary hover:bg-brand-primary hover:text-brand-white hover:no-underline active:bg-brand-primary-darken`,
    linkClasses: `${sharedClasses} bg-transparent text-brand-primary`,
}

export const secondary = {
    solidClasses: `${sharedClasses} bg-brand-secondary text-brand-white hover:text-brand-white hover:no-underline hover:bg-brand-secondary-lighten active:bg-brand-secondary-darken`,
    outlineClasses: `${sharedClasses} bg-transparent text-brand-primary border-2 border-brand-primary hover:bg-brand-primary hover:text-brand-white hover:no-underline active:bg-brand-primary-darken`,
    linkClasses: `${sharedClasses} bg-transparent text-brand-secondary`,
}

export const tertiary = {
    solidClasses: `${sharedClasses} bg-brand-black text-brand-white hover:text-brand-white hover:no-underline hover:bg-brand-black-lighten active:bg-brand-black-darken`,
    outlineClasses: `${sharedClasses} bg-transparent text-brand-black border-2 border-brand-black hover:bg-brand-black hover:text-brand-white hover:no-underline active:bg-brand-black-darken`,
    linkClasses: `${sharedClasses} bg-transparent text-brand-black`,
}
